/**
 * 협의체회의록 그리드 컬럼 정의
 * SAC_BASIC 화면 전용 컬럼 정의
 */

import React from 'react';
import { IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import CreateColumn from '../../../../Services/agGrid/createColumn';
import { Button } from '../../../../Components/MUIs';

/** 참석인원 추가(R5) API 행 → 그리드 공통 형식 (직위=rank, 직책=position) */
export const normalizeAttendeeWorkerRow = (raw = {}) => {
  const id = String(raw?.ID ?? raw?.id ?? '').trim();
  const depNm = String(raw?.DEP_NM ?? raw?.depNm ?? '').trim();
  const rank = String(raw?.RANK ?? raw?.rank ?? '').trim();
  const position = String(raw?.POSITION ?? raw?.position ?? '').trim();
  const name = String(raw?.NAME ?? raw?.name ?? '').trim();
  const tel = String(raw?.TEL ?? raw?.tel ?? '').trim();
  const empNo = String(
    raw?.EMP_NO ?? raw?.empNo ?? raw?.EmployeeNo ?? raw?.employeeNo ?? ''
  ).trim();
  const internalYnRaw =
    raw?.internalYn ?? raw?.InternalYn ?? raw?.INTERNAL_YN ?? '0';
  const internalYn =
    internalYnRaw === 1 ||
    internalYnRaw === '1' ||
    internalYnRaw === true
      ? '1'
      : '0';

  return {
    ...raw,
    id,
    ID: id,
    depNm,
    DEP_NM: depNm,
    rank,
    RANK: rank,
    position,
    POSITION: position,
    name,
    NAME: name,
    tel,
    TEL: tel,
    empNo,
    EMP_NO: empNo,
    internalYn,
    InternalYn: internalYn,
  };
};

/** 외부인 여부 (internalYn='1') */
export const IsExternalAttendeeWorker = (row = {}) => {
  const yn = row?.internalYn ?? row?.InternalYn ?? row?.INTERNAL_YN ?? '0';
  return yn === 1 || yn === '1' || yn === true;
};

/** 서명요청 이후 회의록 수정 잠금 */
export const IsMeetingMinutesLocked = (row = {}) => {
  const yn =
    row?.signRequestYn ?? row?.SignRequestYn ?? row?.SIGN_REQUEST_YN ?? 'N';
  return yn === 'Y' || yn === '1' || yn === true;
};

export const getAttendeeWorkerKey = (worker = {}) => {
  const id = String(worker?.id ?? worker?.ID ?? '').trim();
  const name = worker?.name ?? worker?.NAME ?? '';
  const empNo = worker?.empNo ?? worker?.EMP_NO ?? '';
  return id || `${name}_${empNo}`;
};

/** 참석인원 추가 확인 시 위원 그리드에 넣을 행 */
export const mapWorkerToAttendeeRow = (worker, gubun) => {
  const row = normalizeAttendeeWorkerRow(worker);
  return {
    depNm: row.depNm,
    id: row.id,
    rank: row.rank,
    position: row.position,
    name: row.name,
    tel: row.tel,
    gubun,
    checkYn: 'N',
    attendYn: 'N',
    checkPath: '',
    nonAttendReason: '',
  };
};

/** 참석인원 추가 팝업 — 검색 결과 그리드 컬럼 */
export const getAttendeePickerColumnDefs = () => [
  CreateColumn('depNm', '소속', 'left', 150, false, false, false, 'text', {
    flex: 1,
    minWidth: 150,
  }),
  CreateColumn('rank', '직위', 'left', 100, false, false, false, 'text', {
    minWidth: 90,
  }),
  CreateColumn('name', '이름', 'left', 100, false, false, false, 'text', {
    minWidth: 90,
  }),
  CreateColumn('position', '직책', 'left', 150, false, false, false, 'text', {
    width: 150,
    minWidth: 150,
    maxWidth: 150,
  }),
  CreateColumn('tel', '전화번호', 'left', 130, false, false, false, 'text', {
    minWidth: 110,
  }),
];

/**
 * 협의체회의록 그리드 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // NO 컬럼 (체크박스 포함)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),
    // 채번 컬럼 (숨김)
    CreateColumn('chaebun', '', 'left', 100, false, false, true, 'text', {
      maxWidth: 100,
    }),
    // 사업장코드 컬럼 (숨김)
    CreateColumn('custCd', '', 'left', 100, false, false, true, 'text', {
      maxWidth: 100,
    }),
    // 회의제목 컬럼
    CreateColumn(
      'proceedingsTitle',
      '회의제목',
      'left',
      350,
      false,
      false,
      false,
      'text',
      {
        width: 350,
        flex: 1,
      }
    ),
    // 회의일시 컬럼
    CreateColumn(
      'proceedingsDate',
      '회의일시',
      'center',
      150,
      false,
      false,
      false,
      'text',
      {
        width: 150,
        valueFormatter: (params) => {
          const date = new Date(params.value);
          if (isNaN(date.getTime())) return '';

          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');

          return `${year}-${month}-${day}`;
        },
      }
    ),
    // 회의장소 컬럼
    CreateColumn(
      'proceedingsLocation',
      '회의장소',
      'center',
      250,
      false,
      false,
      false,
      'text',
      {
        width: 250,
      }
    ),
    // 회의록 버튼 컬럼
    CreateColumn('', '회의록', 'center', 120, false, false, false, 'button', {
      minWidth: 120,
      buttonRenderer: (params) => {
        if (params.data?.newYn === 'Y' || params.data?.editYn === 'Y') {
          return null;
        }
        const locked = IsMeetingMinutesLocked(params.data);
        return (
          <Button
            name={locked ? '조회' : '수정'}
            title={
              locked
                ? '서명 요청 후 회의록은 수정할 수 없습니다. (조회만 가능)'
                : undefined
            }
            sx={{ width: '100%' }}
            onClick={() => props.PopupClickEvent5(params.data)}
          />
        );
      },
    }),
    // 서명 버튼 컬럼
    CreateColumn('', '서명', 'center', 120, false, false, false, 'button', {
      minWidth: 120,
      buttonText: '요청하기',
      buttonCondition: (params) => {
        return !(params.data?.newYn === 'Y' || params.data?.editYn === 'Y');
      },
      buttonClickHandler: (params) => {
        props.SignRequest('0', params.data);
      },
    }),
  ];
};

/**
 * 회의 팝업 — 사용자위원/근로자위원 참석자 그리드 컬럼
 * @param {object} props
 * @param {(updater: (prev: object[]) => object[]) => void} props.setList - 해당 그리드용 setState
 */
export const getColumnDefs2 = (props) => {
  const readOnly = !!props.readOnly;
  return [
    CreateColumn('depNm', '소속', 'left', 150, false, false, false, 'text', {
      flex: 1,
      minWidth: 150,
    }),
    CreateColumn('rank', '직위', 'left', 90, false, false, false, 'text', {
      width: 90,
      minWidth: 80,
      valueGetter: (params) => {
        const d = params.data || {};
        return d.rank || d.RANK || '';
      },
    }),
    CreateColumn('name', '이름', 'left', 90, false, false, false, 'text', {
      width: 90,
      minWidth: 80,
    }),
    CreateColumn('position', '직책', 'left', 150, false, false, false, 'text', {
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      valueGetter: (params) => {
        const d = params.data || {};
        return d.position || d.POSITION || '';
      },
    }),
    CreateColumn('tel', '전화번호', 'left', 120, false, false, false, 'text', {
      width: 120,
      minWidth: 110,
    }),
    CreateColumn('actions', '삭제', 'center', 30, false, false, false, 'text', {
      hide: readOnly,
      cellRenderer: (params) => (
        <IconButton
          size="small"
          color="error"
          onClick={() => {
            props.setList((prev) =>
              prev.filter((_, index) => index !== params.rowIndex)
            );
          }}
          sx={{
            padding: '4px',
            '&:hover': {
              bgcolor: '#ffebee',
            },
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
      sortable: false,
      filter: false,
      resizable: false,
    }),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
  getAttendeePickerColumnDefs,
};

export default columnDefs;
